export const dateTimeMixin = {
  methods: {
    getDateTime: function(zone, region){
      var dst = 0
      var time = new Date()
      var gmtMS = time.getTime() + (time.getTimezoneOffset() * 60000)
      var gmtTime = new Date(gmtMS)
      var day = gmtTime.getDate()
      var month = gmtTime.getMonth()
      var year = gmtTime.getYear()
      if(year < 1000){
        year += 1900
      }
      var monthArray = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];

      var monthDays = ["31", "28", "31", "30", "31", "30", "31", "31", "30", "31", "30", "31"]
      if (year%4 === 0){
        monthDays = ["31", "29", "31", "30", "31", "30", "31", "31", "30", "31", "30", "31"]
      }
      if(year%100 === 0 && year%400 !== 0){
        monthDays = ["31", "28", "31", "30", "31", "30", "31", "31", "30", "31", "30", "31"]
      }

      var hr = gmtTime.getHours() + zone
      var min = gmtTime.getMinutes()
      var sec = gmtTime.getSeconds()

      if (hr >= 24){
        hr = hr-24
        day -= -1
      }
      if (hr < 0){
        hr -= -24
        day -= 1
      }
      if (hr < 10){
        hr = " " + hr
      }
      if (min < 10){
        min = "0" + min
      }
      if (sec < 10){
        sec = "0" + sec
      }
      if (day <= 0){
        if (month == 0){
          month = 11
          year -= 1
        }
        else{
          month -= 1
        }
        day = monthDays[month]
      }
      if(day > monthDays[month]){
        day = 1
        if(month == 11){
          month = 0
          year -= -1
        }
        else{
          month -= -1
        }
      }

      if (region == "Europe"){
        var startDST = new Date()
        var endDST = new Date()
        startDST.setMonth(2)
        startDST.setHours(1)
        startDST.setDate(31)
        var dayDST = startDST.getDay()
        startDST.setDate(31-dayDST)
        endDST.setMonth(9)
        endDST.setHours(0)
        endDST.setDate(31)
        dayDST = endDST.getDay()
        endDST.setDate(31-dayDST)
        var currentTime = new Date()
        currentTime.setMonth(month)
        currentTime.setYear(year)
        currentTime.setDate(day)
        currentTime.setHours(hr)
        if(currentTime >= startDST && currentTime < endDST){
          dst = 1
        }
      }
      if (dst === 1){
        hr -= -1
        if (hr >= 24){
          hr = hr-24
          day -= -1
        }
        if (hr < 10){
          hr = " " + hr
        }
        if(day > monthDays[month]){
          day = 1
          if(month == 11){
            month = 0
            year -= -1
          }
          else{
            month -= -1
          }
        }
        return year + "-" + monthArray[month] + "-" + day + " " + hr + ":" + min + ":" + sec + " DST"
      }
      else{
        return year + "-" + monthArray[month] + "-" + day + " " + hr + ":" + min + ":" + sec
      }
    }
  }
}